const MapEmbed = () => {
    return (
        <div className="w-full h-[400px] my-8">
            <iframe
                title="Google Maps - The One Childcare"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3340.860355369275!2d0.0182644!3d51.45408659999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47d8a905252f1b7f%3A0x3fa14d1da64bba0c!2sThe%20One%20Childcare!5e1!3m2!1sen!2suk!4v1746295486590!5m2!1sen!2suk" // replace with your embed URL
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
            />
        </div>
    );
};

export default MapEmbed;

